import form_function from "../helpers/form-functions";

const addFormValidation = () => {
  const web2CaseForms = document.querySelectorAll(
    ".salesforceForm:not(.web_to_lead)"
  );
  const web2LeadForms = document.querySelectorAll(
    ".salesforceForm.web_to_lead"
  );
  const formsArray = [];
  if (web2CaseForms.length > 0) {
    formsArray.push(web2CaseForms);
  }
  if (web2LeadForms.length > 0) {
    formsArray.push(web2LeadForms);
  }
  if (formsArray.length > 0) {
    formsArray.forEach((forms) => {
      forms.forEach((form) => {
        form_function.formValidation(form);
        form.addEventListener("submit", async (event) => {
          const sendFormForValidation = await form_function.finalValidation(
            event
          );
          return sendFormForValidation;
        });
      });
    });
  } else {
    console.warn(`wpro_debug__form-check:: No SF forms found.`);
  }
};


document.addEventListener("DOMContentLoaded", (event) => {
  window.add_form_validation = () => addFormValidation();
  window.add_form_validation();
  window.captchaResponse = (response) => {
    console.log("wpro_debug__response__object")
    console.log({wpro_debug__response__object:response})
  }
});
